import { SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs';
import { setFundChartSortColumn } from 'ChartApp/ts/apps/fund-chart/state/reducers/sort-column/sort-column.actions';
import { setFundChartSortDirection } from 'ChartApp/ts/apps/fund-chart/state/reducers/sort-direction/sort-direction.actions';
import { ASC, DESC } from 'NewAngular/constants/core.constants';
import { DataInLegendOption } from 'ChartApp/ts/enums/fund-chart-common.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
const _c0 = a0 => ({ top: a0 });
const _c1 = a0 => ({ "chart-legend-annualized-data": a0 });
const _c2 = (a0, a1) => ({ "th-sort-asc": a0, "th-sort-desc": a1 });
const _c3 = a0 => ({ backgroundColor: a0 });
function FundChartLegendComponent_ng_container_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} if (rf & 2) {
    const offset_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(2, _c0, offset_r1 - 1 + "px"));
} }
function FundChartLegendComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FundChartLegendComponent_ng_container_0_ng_container_1_div_1_Template, 1, 4, "div", 3);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const last_r2 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !last_r2);
} }
function FundChartLegendComponent_ng_container_0_div_2_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function FundChartLegendComponent_ng_container_0_div_2_div_1_div_5_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r3 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r3.setSort("value")); });
    i0.ɵɵtext(1, " VAL ");
    i0.ɵɵelement(2, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c2, ctx_r3.sortDirection == ctx_r3.ASC, ctx_r3.sortDirection == ctx_r3.DESC));
} }
function FundChartLegendComponent_ng_container_0_div_2_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1, " ANN ");
    i0.ɵɵelementEnd();
} }
function FundChartLegendComponent_ng_container_0_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵelement(2, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 11);
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, FundChartLegendComponent_ng_container_0_div_2_div_1_div_5_Template, 3, 4, "div", 13)(6, FundChartLegendComponent_ng_container_0_div_2_div_1_div_6_Template, 2, 0, "div", 14);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r3.showValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showAnnualizedValue);
} }
function FundChartLegendComponent_ng_container_0_div_2_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 23);
} if (rf & 2) {
    const series_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", series_r5.val2 !== "" ? series_r5.val2 : "");
} }
function FundChartLegendComponent_ng_container_0_div_2_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
} if (rf & 2) {
    const series_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", series_r5.annualizedValue ? series_r5.annualizedValue + "%" : "--");
} }
function FundChartLegendComponent_ng_container_0_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9)(2, "span", 18);
    i0.ɵɵelement(3, "span", 19);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "div", 20);
    i0.ɵɵelementStart(6, "div", 12);
    i0.ɵɵtemplate(7, FundChartLegendComponent_ng_container_0_div_2_div_2_div_7_Template, 1, 1, "div", 21)(8, FundChartLegendComponent_ng_container_0_div_2_div_2_div_8_Template, 1, 1, "div", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const series_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(6, _c3, series_r5.color));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", series_r5.longLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", series_r5.val1 !== "" ? series_r5.val1 : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.showValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showAnnualizedValue);
} }
function FundChartLegendComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, FundChartLegendComponent_ng_container_0_div_2_div_1_Template, 7, 2, "div", 6)(2, FundChartLegendComponent_ng_container_0_div_2_div_2_Template, 9, 8, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const chart_r6 = ctx.$implicit;
    const index_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(6, _c0, ctx_r3.subchartOffsets[index_r7] + "px"));
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(8, _c1, ctx_r3.showAnnualizedValue || ctx_r3.showValue));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showAnnualizedValue || ctx_r3.showValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", chart_r6);
} }
function FundChartLegendComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FundChartLegendComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 1)(2, FundChartLegendComponent_ng_container_0_div_2_Template, 3, 10, "div", 2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.subchartOffsets);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.tooltipData);
} }
/**
 * FundChartLegendComponent
 *
 * Inputs:
 * dataInLegend: which data to show in the legend (value, value and annualized value, annualized value only, or none)
 * subchartOffsets: List of offsets, example: [0, 270, 580]
 * tooltipData: List of JS Objects representing tooltipData
 */
export class FundChartLegendComponent {
    constructor(store) {
        this.store = store;
        this.dataInLegend = DataInLegendOption.VALUE;
        this.showAnnualizedValue = false;
        this.showValue = true;
        this.sortColumn = '';
        this.sortDirection = '';
        this.ASC = ASC;
        this.DESC = DESC;
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            // This component is used on other pages in addition to the main fund chart page.
            // FundChartRootStore will not be defined outside of the main fund chart page.
            // We don't need to do anything here in that case.
            if (state?.fundChart) {
                this.sortColumn = state.fundChart.sortColumn;
                this.sortDirection = state.fundChart.sortDirection;
            }
        };
    }
    ngOnInit() {
        this.store
            .select('reducers')
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    ngOnChanges(changes) {
        if (changes.dataInLegend?.currentValue) {
            this.showValue =
                this.dataInLegend === DataInLegendOption.VALUE ||
                    this.dataInLegend === DataInLegendOption.VALUE_AND_ANNUALIZED_VALUE;
            this.showAnnualizedValue =
                this.dataInLegend === DataInLegendOption.ANNUALIZED_VALUE ||
                    this.dataInLegend === DataInLegendOption.VALUE_AND_ANNUALIZED_VALUE;
        }
    }
    setSort(sortColumn) {
        const sortDirection = this.sortDirection === ASC ? DESC : ASC;
        this.store.dispatch(setFundChartSortColumn({ sortColumn }));
        this.store.dispatch(setFundChartSortDirection({ sortDirection }));
    }
}
FundChartLegendComponent.ɵfac = function FundChartLegendComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartLegendComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
FundChartLegendComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartLegendComponent, selectors: [["ycn-fund-chart-legend"]], inputs: { dataInLegend: "dataInLegend", subchartOffsets: "subchartOffsets", tooltipData: "tooltipData" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "chart-legend col-lg-8", 3, "class", "style", 4, "ngFor", "ngForOf"], ["class", "chart-separator", 3, "style", 4, "ngIf"], [1, "chart-separator"], [1, "chart-legend", "col-lg-8"], ["class", "chart-legend-item", 4, "ngIf"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-legend-item"], [1, "chart-legend-item-name"], [1, "chart-legend-item-title"], [1, "chart-legend-item-date"], [1, "chart-legend-item-value"], ["class", "col-sm-6 cursor-pointer", 3, "ngClass", "click", 4, "ngIf"], ["class", "col-sm-6", 4, "ngIf"], [1, "col-sm-6", "cursor-pointer", 3, "click", "ngClass"], [1, "sort-mark"], [1, "col-sm-6"], [1, "chart-legend-item-title", "chart-bullet"], [1, "chart-bullet-point"], [1, "chart-legend-item-date", 3, "textContent"], ["class", "col-sm-6", "data-test-id", "chart-legend-item-value", 3, "textContent", 4, "ngIf"], ["class", "col-sm-6", "data-test-id", "chart-legend-item-value-annualized", 3, "textContent", 4, "ngIf"], ["data-test-id", "chart-legend-item-value", 1, "col-sm-6", 3, "textContent"], ["data-test-id", "chart-legend-item-value-annualized", 1, "col-sm-6", 3, "textContent"]], template: function FundChartLegendComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FundChartLegendComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.tooltipData && ctx.tooltipData.length > 0);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf], encapsulation: 2 });
